export default "__VITE_ASSET__BWLVbPUP__"